import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaginationService } from './pagination.service';
import { PaginatedResponse } from '../models/paginations/paginated-response.model';
import { ApiResponse } from '../models/api-response/api-response.model';
import { TransactionForCreation } from '../models/transactions/transaction-for-creation.model';
import { TransactionForListing } from '../models/transactions/transaction-for-listing.model';
import { TransactionForUpdation } from '../models/transactions/transaction-for-updation.model';
import { TransactionDto } from '../models/transactions/transaction.model';
import { TransactionsRequestFilter } from '../models/transactions/transaction-request-filter.model';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {
  private apiUrl = `${environment.apiUrl}/transactions`;

  constructor(private http: HttpClient, private paginationService: PaginationService) { }

  getPaginatedTransactions(filter: TransactionsRequestFilter): Observable<PaginatedResponse<TransactionForListing>> {
    return this.paginationService.getPaginatedData<TransactionForListing>(this.apiUrl, filter);
  }

  getTransactionById(id: number): Observable<TransactionDto> {
    return this.http.get<TransactionDto>(`${this.apiUrl}/${id}`);
  }

  createTransaction(data: TransactionForCreation): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.apiUrl, data);
  }

  updateTransaction(data: TransactionForUpdation): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(this.apiUrl, data);
  }

  softDeleteTransaction(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.apiUrl}/soft/${id}`);
  }
}
